export default __webpack_public_path__ + "static/media/sector_2w.14352dfe.jpg";